import { Injectable } from "@angular/core";
import { VersaoService, Versao } from "@services/versao.service";
import { EnvService } from "@services/env.service"
import { AuthService } from "@services/auth.service";

declare let gtag: (type: string, name: string, params?: any) => void;

export interface userSegmentationProperties {
  versao: string,
  cliente: string,
  ambiente: string,
}

@Injectable({
  providedIn: "root"
})
export class GoogleAnalyticsService {

  constructor(
    private _versaoService: VersaoService,
    public authSrv: AuthService,
  ) { }

  GA_CODE=`G-95XSYJQCX6`
  LOCAL_STORAGE_KEY = `invoicecon-ga-consent`

  /**
   * Gera um evento que é enviado para o google analytics
   * @param eventName
   * @param params
   */
  emitEvent(eventName: string, params?: Record<string, any>): void {
    if(localStorage.getItem(this.LOCAL_STORAGE_KEY) === 'granted') {
      gtag('event', eventName, {...params, userEmail: this.authSrv.usuario.email.split('@')[0]});
    }
  }

  /**
   * Gera um evento especial 'page_view' toda vez que mudar de página
   * @param title
   * @param event
   */
  emitPageView(pageTitle: string, pagePath: string) {
    if(localStorage.getItem(this.LOCAL_STORAGE_KEY) === 'granted') {
      if(pagePath.split("?")[0] !== "/") {
        gtag('event', 'page_view', {
          page_path: pagePath.split("?")[0],
          page_location: window.location.href,
          page_title: pageTitle
        })
      }
    }
  }

  /**
   * Começar a sessão segmentando o usuário. Tem que fazer isso logo quando começa o GA.
   * @param properties
   */
  async setUserSegmentation(): Promise<void> {
    this._versaoService.fetchVersao().then((versao: Versao) => {
      let ambiente = EnvService.ambienteHeader;
      if (EnvService.ambienteHeader !== 'localhost') {
        ambiente = EnvService.ambienteHeader.substring(0, 3);
      }

      let versaoFormatted = "";

      if (versao) {
        // se for uma versão para cliente, mostra apenas a versão e não a subversão ("V.1.36" inves de "V.1.36.XX_<datetime>" )
        if(versao.interface.includes("V.")) {
          versaoFormatted = versao.interface.substring(0, 6)
        } else {
          versaoFormatted = versao.interface || ""
        }
      }

      const properties: userSegmentationProperties = {
        versao: versaoFormatted,
        cliente: EnvService.cliente,
        ambiente,
      }

      gtag('set', 'user_properties', properties);
      gtag('config', this.GA_CODE, {
        anonymize_ip: true,
        send_page_view: false,
      });
    });
  }

  /**
   * Verifica e define o consent do GA do usuario.
   */
  onInitConsent(): void {
    const consent: string = localStorage.getItem(this.LOCAL_STORAGE_KEY) || 'denied'

    gtag('consent', 'update', {
      analytics_storage: consent
    })
  }

  /**
   * manda 'granted' ou 'denied' para ver como está no localhost. Se voltar null é porque não fez a decisão ainda
   */
  haveConsent(): string | null {
    return localStorage.getItem(this.LOCAL_STORAGE_KEY)
  }

  /**
   * Define no consent para vermos as coisas no GA.
   */
  defineConsent(answer: 'granted' | 'denied'): void {
    localStorage.setItem(this.LOCAL_STORAGE_KEY, answer)

    gtag('consent', 'update', {
      analytics_storage: answer
    })
  }
}


